(() => {
  const inputs = [...document.querySelectorAll('[data-hk-slug]')];
  const summary = document.getElementById('hk-summary');
  const mail = document.getElementById('hk-mail');
  const copy = document.getElementById('hk-copy');
  const status = document.getElementById('hk-inquiry-status');
  if (!summary) return;
  const params = new URLSearchParams(location.search);
  const aliases = {brutal: 'Brutal', todesmutig: 'Todesmutig'};
  const requested = params.get('produkt');
  const selected = aliases[requested] ? 'traust-di-nie' : requested;
  const variant = params.get('variante') || aliases[requested] || 'Hot';
  // One incoming selection must choose one variant, never all three bottles.
  const match = inputs.find(input => input.dataset.hkSlug === selected && (!input.dataset.hkVariant || input.dataset.hkVariant === variant));
  if (match) match.value = '1';
  for (const input of inputs) input.addEventListener('input', update);
  function update() {
    const items = inputs.map(input => {
      const number = Number(input.value);
      const quantity = Number.isFinite(number) ? Math.min(99, Math.max(0, Math.floor(number))) : 0;
      input.value = String(quantity);
      return quantity ? `${quantity} Stück · ${input.dataset.hkName}` : null;
    }).filter(Boolean);
    summary.value = items.length ? 'Servus HULZKNECHT,\n\nich interessiere mich unverbindlich für:\n\n' + items.join('\n') + '\n\nBitte bestätigt mir Verfügbarkeit, Preise inklusive Versand sowie die vollständigen Produktinformationen vor meiner Bestellung.\n\nName:\nLieferadresse:\nTelefon (optional):\n\nVielen Dank!' : '';
    mail.hidden = !items.length;
    copy.disabled = !items.length;
    mail.href = items.length ? 'mailto:office@gartenbau-krenn.at?subject=' + encodeURIComponent('HULZKNECHT – unverbindliche Bestellanfrage') + '&body=' + encodeURIComponent(summary.value) : '';
    status.textContent = items.length ? 'Deine Anfrage ist vorbereitet. Das E-Mail-Programm versendet sie erst nach deiner Freigabe.' : 'Wähle mindestens eine Sorte.';
  }
  copy.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(summary.value); status.textContent = 'Anfragetext kopiert.'; }
    catch { summary.select(); status.textContent = 'Bitte den markierten Text kopieren.'; }
  });
  update();
})();
